import React from 'react'
import workInProgressImg from 'assets/img/workInProgress.png'
import keepapiLogo from 'assets/img/keepapiLogo.png'
import logoMahFondTranparent from 'assets/img/header-logo-catho.png'
import { Grid,Link as MuiLink,useMediaQuery } from '@mui/material'
import MaintenanceTimer from './MaintenanceTimer'
import styles from './styles'
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme) => styles)

const keepapiLink = 'https://keepapi.com';
const MahLink = 'https://mah.univ-catholille.app/';

const WorkInProgressView = ({...props}) => {
    const isMobile = useMediaQuery('(max-width:600px)');
    const { classes } = useStyles()
    const maintenance = () => {
        window.localStorage.setItem('flagByPassMaintenance',false)
        window.location.href="/"
    }
    return (
      <Grid
        container
        direction="column"
        justify="center"
        alignItems="center"
      >
          <Grid container px={1} justifyContent="space-between" sx={{ position: 'fixed' }}>
              <Grid item>
                  <MuiLink href={keepapiLink} target="_blank" underline="none" >
                      <img
                        height={isMobile ? '50px' : '100px'}
                        src={keepapiLogo}
                        alt="Keepapi Logo"
                      />
                  </MuiLink>
              </Grid>
              <Grid item >
                  <MuiLink href={MahLink} target="_blank" underline="none">
                      <img
                        height={isMobile ? '50px' : '100px'}
                        src={logoMahFondTranparent}
                        alt="Mah Logo"
                      />
                  </MuiLink>
              </Grid>
          </Grid>
          <Grid item>
              <img  height={isMobile ? '300px' : '500px'} src={workInProgressImg} alt="work in progress by keepapi team"/>
          </Grid>
          <Grid item>
              <div className={classes.keepapi}>
                  Votre application est actuellement indisponible. <br/>
                  Nous procédons à sa mise à jour.
                  <br/>
                  Nous vous prions de bien vouloir nous excuser pour la gêne occasionnée.<br/>
                  Fin de la maintenance prévue dans :
                  <MaintenanceTimer maintenanceDateTime={props.dateMaintenance}/>

                  <br/>
                  <MuiLink   href={keepapiLink} color="inherit" underline="none" target="_blank"> <b className={classes.golden}>L'équipe {'{'} Keep : Api {'}'}</b></MuiLink>

              </div>
              <span style={{position: 'absolute',right: 3,bottom: 3,color: 'white'}} onClick={() => maintenance()}>π</span>
          </Grid>

      </Grid>
    )
}
export default WorkInProgressView
